import { colours } from "@shared/ui.design-system";
import {
  type PromotionalBannerResponse,
  type ToDesignSystemColoursResponse
} from "./types";
import type {
  BannerColourNamesEnum,
  PromotionalBannerType
} from "@shared/graphql.types";

export const mapToDesignSystemColours = (
  tokenName: BannerColourNamesEnum
): ToDesignSystemColoursResponse => {
  switch (tokenName) {
    case "WARNING_MEDIUM":
      return {
        colour: colours.warning.medium,
        variant: "warning-medium"
      };
    case "ACCENT_WARM":
      return {
        colour: colours.accent.warm,
        variant: "accent-warm"
      };
    case "SECONDARY_LIGHT":
      return {
        colour: colours.secondary.light,
        variant: "secondary-light"
      };
    case "PRIMARY_DARK":
    default:
      return {
        colour: colours.primary.dark,
        variant: "primary-dark"
      };
  }
};

export const mapPromotionalBannerDetails = (
  details: PromotionalBannerType
): PromotionalBannerResponse => {
  const backgroundColourToDesignSystem = mapToDesignSystemColours(
    details.backgroundColour.tokenName
  );
  const fontColourToDesignSystem = mapToDesignSystemColours(
    details.fontColour.tokenName
  );

  return {
    ...details,
    // pagesToExclude: [...details.pagesToExclude, "/account/my-membership"],
    backgroundColour: backgroundColourToDesignSystem.colour,
    fontColour: fontColourToDesignSystem.variant
  };
};
